"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = require("./IconButton.style");

var _styledSystem = require("styled-system");

var _Circular = _interopRequireDefault(require("../loaders/Circular"));

var _excluded = ["children", "component", "loading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var IconButton = function IconButton(_ref) {
  var children = _ref.children,
      component = _ref.component,
      loading = _ref.loading,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_IconButton.StyledIconButton, (0, _extends2["default"])({}, props, {
    as: component
  }), loading ? /*#__PURE__*/_react["default"].createElement(_Circular["default"], {
    size: "xs",
    color: props.disabled ? 'base' : props.color
  }) : /*#__PURE__*/_react["default"].createElement(_IconButton.StyledIcon, null, children));
};

IconButton.defaultProps = {
  color: 'primary',
  size: 36,
  variant: 'fill',
  radius: 50,
  loading: false,
  component: 'button'
};
IconButton.propTypes = _objectSpread(_objectSpread({
  className: _propTypes["default"].string,
  size: _propTypes["default"].number.isRequired,
  variant: _propTypes["default"].oneOf(['fill', 'plain', 'outlined']).isRequired,
  color: _propTypes["default"].oneOf(['base', 'primary', 'secondary']).isRequired
}, _styledSystem.space.propTypes), {}, {
  disabled: _propTypes["default"].bool,

  /**
   * (event) => {}
   */
  onClick: _propTypes["default"].func,
  loading: _propTypes["default"].bool
});
var _default = IconButton;
exports["default"] = _default;